(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-ads-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.sm-ads-landing');
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const landingVariant = root.dataset.landingVariant || 'B';
    const formatMoney = (cents) => new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);

    const pushEvent = (event, details = {}) => {
      const payload = { event, landing_variant: landingVariant, ...details };
      const eventQueue = window.sleepMartLandingEvents = window.sleepMartLandingEvents || [];
      eventQueue.push(payload);
      if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
        window.dataLayer = [];
      }
      window.dataLayer.push(payload);
      window.dispatchEvent(new CustomEvent('sleepmart:landing-event', { detail: payload }));
      root.dataset.lastEvent = event;
    };

    const campaignKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid'];
    const currentParams = new URLSearchParams(window.location.search);
    const campaignParams = new URLSearchParams();
    campaignKeys.forEach((key) => {
      const value = currentParams.get(key);
      if (value) campaignParams.set(key, value);
    });
    campaignParams.set('landing_variant', landingVariant);

    root.querySelectorAll('[data-product-link]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      campaignParams.forEach((value, key) => url.searchParams.set(key, value));
      link.href = url.toString();
    });

    root.querySelectorAll('.sm-product-form').forEach((form) => {
      campaignKeys.forEach((key) => {
        const value = currentParams.get(key);
        if (!value) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[_${key}]`;
        input.value = value;
        form.appendChild(input);
      });
    });

    root.querySelectorAll('[data-track-cta]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('landing_cta_click', { cta_name: link.dataset.trackCta });
      });
    });

    root.querySelectorAll('[data-whatsapp-link]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('landing_whatsapp_click', { destination: '525553596929' });
      });
    });

    root.querySelectorAll('[data-track-product]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('landing_select_item', { item_id: link.dataset.trackProduct });
      });
    });

    root.querySelectorAll('[data-product-card]').forEach((card) => {
      const select = card.querySelector('[data-variant-select]');
      const price = card.querySelector('[data-product-price]');
      const monthly = card.querySelector('[data-monthly-price]');
      const gift = card.querySelector('[data-selected-gift]');
      const form = card.querySelector('.sm-product-form');

      const updateVariant = () => {
        const option = select.options[select.selectedIndex];
        const cents = Number(option.dataset.price || 0);
        const title = (option.dataset.variantTitle || '').toLowerCase();
        price.textContent = formatMoney(cents);
        const months = cents >= 1000000 ? 12 : cents >= 300000 ? 6 : 0;
        monthly.textContent = months > 0
          ? `o ${months} pagos sin intereses de ${formatMoney(Math.round(cents / months))} con Mercado Pago`
          : 'MSI disponibles en compras desde $3,000';
        gift.textContent = 'Incluye 1 Almohada Spring Air Oso gratis';
      };

      select.addEventListener('change', () => {
        updateVariant();
        pushEvent('landing_variant_select', {
          item_id: card.dataset.productHandle,
          variant_id: select.value
        });
      });

      form.addEventListener('submit', () => {
        pushEvent('landing_add_to_cart', {
          item_id: card.dataset.productHandle,
          variant_id: select.value
        });
      });

      updateVariant();
    });

    const filterButtons = root.querySelectorAll('[data-firmness-filter]');
    const cards = root.querySelectorAll('[data-product-card]');
    const noResults = root.querySelector('[data-no-results]');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.firmnessFilter;
        let visible = 0;
        filterButtons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach((card) => {
          const show = filter === 'all' || card.dataset.firmness === filter;
          card.hidden = !show;
          if (show) visible += 1;
        });
        noResults.hidden = visible > 0;
        pushEvent('landing_firmness_select', { firmness: filter });
      });
    });

    pushEvent('view_campaign_landing', { page_type: 'mattress_finder' });
  })();

  } catch(e) { console.error(e); }
})();
})();
